import { useTranslation } from 'react-i18next';

const fallbackPortrait = "data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='400' height='500'%3E%3Crect width='400' height='500' fill='%23e8ddd0'/%3E%3Ctext x='50%25' y='50%25' dominant-baseline='middle' text-anchor='middle' font-family='serif' font-size='24' fill='%237a6a5a'%3EUser%3C/text%3E%3C/svg%3E";

export default function Testimonial() {
  const { t } = useTranslation();

  return (
    <section className="py-16 md:py-24 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col md:flex-row gap-10 md:gap-16 items-center">
          <div className="md:w-2/5 flex justify-center">
            <div className="w-56 h-72 md:w-64 md:h-80 rounded-2xl overflow-hidden bg-background-50 border border-background-200/60">
              <img
                src="https://readdy.ai/api/search-image?query=Young%20woman%20in%20casual%20elegant%20outfit%20sitting%20in%20modern%20minimal%20interior%20soft%20natural%20light%20warm%20tones%20relaxed%20pose%20friendly%20smile%20editorial%20lifestyle%20photography%20European%20aesthetic%20clean%20composition%20no%20text%20no%20logos%20high%20detail&width=400&height=500&seq=testimonial-portrait-v2&orientation=portrait"
                alt="Happy Kakobuy customer from Warsaw"
                title="Kakobuy Spreadsheet – Zadowolona klientka"
                className="w-full h-full object-cover object-top"
                onError={(e) => { (e.target as HTMLImageElement).src = fallbackPortrait; }}
              />
            </div>
          </div>

          <div className="md:w-3/5 text-center md:text-left">
            <i className="ri-double-quotes-l text-4xl text-primary-300"></i>
            <blockquote className="mt-4 font-heading text-xl md:text-2xl lg:text-3xl font-bold text-foreground-950 leading-snug">
              "{t('testimonial.quote')}"
            </blockquote>
            <div className="mt-6 flex flex-col md:flex-row items-center gap-3 md:gap-6 justify-center md:justify-start">
              <span className="text-sm font-bold text-foreground-900">{t('testimonial.author')}</span>
              <span className="hidden md:inline text-foreground-300">|</span>
              <span className="text-xs text-foreground-500">Warszawa, Polska</span>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}